import React from 'react';
import { asset } from '@/lib/api';
import { useSite } from '@/context/SiteContext';
import { MagneticButton } from '@/components/MagneticButton';
import { Reveal } from '@/components/Reveal';

export const CtaSection = () => {
  const { site } = useSite();
  const cta = site?.cta;
  if (!cta) return null;
  return (
    <section className='relative overflow-hidden bg-[#20272A]'>
      {cta.image && (
        <img src={asset(cta.image)} alt='' className='absolute inset-0 h-full w-full object-cover opacity-40' />
      )}
      <div
        className='absolute inset-0'
        style={{ background: 'linear-gradient(120deg, rgba(7,91,97,0.92) 0%, rgba(32,39,42,0.86) 60%, rgba(32,39,42,0.92) 100%)' }}
      />
      <div className='grain absolute inset-0' />
      <div className='relative container-x py-20 lg:py-28'>
        <div className='max-w-3xl'>
          <Reveal>
            <div className='flex items-center gap-3'>
              <span className='h-px w-10 bg-[#B88A3B]' />
              <span className='eyebrow text-[#B88A3B]'>{cta.eyebrow}</span>
            </div>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className='mt-5 font-head text-4xl sm:text-5xl lg:text-[3.4rem] font-semibold leading-[1.05] tracking-[-0.02em] text-[#F6F5F1]'>
              {cta.headline}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className='mt-6 max-w-xl text-lg text-[#F6F5F1]/75'>{cta.text}</p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className='mt-9 flex flex-wrap gap-4'>
              <MagneticButton to='/contact' variant='gold' data-cursor='ENQUIRE'>Discuss Your Project</MagneticButton>
              <MagneticButton to='/projects' variant='secondary' className='text-[#F6F5F1]' data-cursor='VIEW'>
                View Our Projects
              </MagneticButton>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
